// Function for handling all ajax errors
import { CaseReducer, ActionReducerMapBuilder } from '@reduxjs/toolkit';

import { InputSliceState } from 'features/input/inputSliceTypes';
import { MatchSliceState } from 'features/match/matchSliceTypes';

type SliceState = MatchSliceState | InputSliceState;

function handleRejected(builder: ActionReducerMapBuilder<SliceState>, thunks: any[], callback: CaseReducer): void {
  thunks.forEach((promise) => {
    builder.addCase(promise.rejected, callback);
  });
}

export default handleRejected;
